import React from "react"
import { useDispatch, useSelector } from "react-redux"
import { AppBar, Box, Button, IconButton, Toolbar, useMediaQuery, useTheme } from "@mui/material"
import { useLocation, useNavigate } from "react-router-dom"
import MenuIcon from "@mui/icons-material/Menu"
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft"
import AccountInfo from "../../AccountInfo"
import { isLogisticaOnly } from "../../../helpers/logisticaHelper"
import { logisticaActions } from "../../../actions/logisticaActions"
import { logisticaItems, navbarHeight } from "../logisticaNav"

const Logo = `${process.env.PUBLIC_URL}/assets/logo-pizzini.png`

const styles = {
    toolBar: {
        backgroundColor: "white",
        color: "black",
        height: navbarHeight,
        minHeight: navbarHeight,
        padding: "0 16px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "8px"
    },
    logo: {
        cursor: "pointer",
        width: "auto",
        display: "block"
    }
}

export default function NavbarLogistica() {
    const theme = useTheme()
    const mobile = useMediaQuery(theme.breakpoints.down("md"))
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()
    const { roles } = useSelector(state => state.account)
    const { drawerOpen } = useSelector(state => state.logistica)
    // El botón del drawer solo va en las pantallas que usan LogisticaLayout
    const conDrawer = logisticaItems.some(item => location.pathname.includes(item.path))
    // El usuario que solo tiene Logistica no tiene acceso al portal
    const soloLogistica = isLogisticaOnly(roles)

    return (
        <AppBar position="static" sx={{ backgroundColor: "white", boxShadow: 1 }}>
            <Toolbar disableGutters style={styles.toolBar}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0 }}>
                    {conDrawer && (
                        <IconButton onClick={() => dispatch(logisticaActions.toggleDrawer())} aria-label="Menú">
                            {drawerOpen ? <ChevronLeftIcon /> : <MenuIcon />}
                        </IconButton>
                    )}
                    <img
                        src={Logo}
                        alt="Pizzini"
                        style={{ ...styles.logo, height: mobile ? 32 : 44, maxWidth: "100%" }}
                        onClick={() => navigate(soloLogistica ? "/logistica" : "/")}
                    />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                    {!soloLogistica && (
                        <Button onClick={() => navigate("/products")} sx={{ borderRadius: "10px" }}>
                            Portal
                        </Button>
                    )}
                    <AccountInfo />
                </Box>
            </Toolbar>
        </AppBar>
    )
}
